export default __webpack_public_path__ + "static/media/master-card.0defb574.svg";